import Vue from 'vue'
import Vuex from 'vuex'
import comData from './common.js'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    comData,
    activeRouter:"",
    routerAlive:true,
    comUrl:'requestMainMobile/pageService/newsList',
    screenWidth:document.documentElement.clientWidth, //屏幕宽度
    screenHeight:document.documentElement.clientHeight, //屏幕高度
  },
  mutations: {
    updataRouter: function(state,params){
      state.activeRouter = params
    },
    RouterAliveIsTrue: function(state,params){
      state.routerAlive = true
    },
    RouterAliveIsFalse: function(state,params){
      state.routerAlive = false
    }
  },
  actions: {
  },
  modules: {
  },
  // plugins:[persistedState()]
})
